function getInventoryReasons() {
  return [
    {
      value: 'END_OF_PERIOD',
      labelId: 'inventory.form.modal.inventoryReason.endOfPeriod',
    },
    {
      value: 'TAX_CHANGE',
      labelId: 'inventory.form.modal.inventoryReason.changeFormGoods',
    },
    {
      value: 'COMMIT_REGISTRATION',
      labelId: 'inventory.form.modal.inventoryReason.registrationLowRequest',
    },
    {
      value: 'PAYMENT_SCHEME_CHANGE',
      labelId: 'inventory.form.modal.inventoryReason.changeOfPaymentRegime',
    },
    {
      value: 'MANDATE',
      labelId: 'inventory.form.modal.inventoryReason.taxDetermination',
    },
  ];
}

export default getInventoryReasons;
